import React from 'react';
import { TbRocket } from 'react-icons/tb';
import { Link } from 'react-router-dom';

import { Button } from '@/components/molecules/Button';
import { PageTitle } from '@/components/molecules/PageTitle';

type Props = {
  firstTitle?: string;
  secondTitle?: string;
  children?: React.ReactNode | React.ReactNode[];
  restaurantId?: string;
  bottomPadding?: boolean;
  id?: string;
  askBoostVisibility?: boolean;
};

export const TabPageLayout = ({
  children,
  id,
  firstTitle,
  secondTitle,
  restaurantId,
  bottomPadding = true,
  askBoostVisibility: asBoostVisibility = true
}: Props): JSX.Element => {
  return (
    <>
      {firstTitle && <PageTitle id={id} firstTitle={firstTitle} secondTitle={secondTitle} />}
      <div className="flex justify-center mb-6">
        {asBoostVisibility && (
          <Link to={`/restaurant/subscription/${restaurantId}`}>
            <Button
              label="Booster la visibilité de mon restaurant"
              color="secondary"
              icon={<TbRocket className="text-lg mr-1" />}
              onClick={() => {
                /* TODO: Implement visibility boost functionality */
              }}
              marginClass="px-8"
            />
          </Link>
        )}
      </div>
      <div className="py-4 md:py-5 space-y-12">{children}</div>
      {bottomPadding && <div className="md:py-10 py-5" />}
      {/* {restaurantId && <BoostRestoAdBanner restaurantId={restaurantId} />} */}
    </>
  );
};
